<template>
    <div class="context">
        <div class="header">
            <div class="btn_box">
                <div class="btn nomal_btn" @click="goBack">
                    <i class="el-icon-back"></i>
                    返回
                </div>
            </div>
            <div class="title">{{viewTitle}}</div>
        </div>
        <div class="form_box">
            <div class="header_box">
                <el-checkbox @click="changeHeaderType" v-model="start">期初</el-checkbox>
                <el-checkbox @click="changeHeaderType" v-model="middle">期中</el-checkbox>
                <el-checkbox @click="changeHeaderType" v-model="end">期末</el-checkbox>
            </div>
            <el-form :model="form" inline ref="form" :rules="rules" label-width="60px">
                <el-form-item v-if="start" label="期初">
                    <el-card shadow="never"
                             v-if="form.start"
                             class="card_item">
                        <div class="btn_box">
                            <div class="icon" @click="delRow('start')">
                                <el-tooltip class="item"
                                            effect="dark"
                                            content="删除"
                                            placement="top">
                                    <i class="el-icon-delete"></i>
                                </el-tooltip>
                            </div>
                        </div>
                        <div class="img_box" @click="lookRow(form.start)">
                            <img :src="showImgUrl(form.start)">
                        </div>
                        <div @click="lookRow(form.start)" class="title">
                            {{form.start.title}}
                        </div>
                        <div @click="lookRow(form.start)" class="text">
                            {{form.start.brief}}
                        </div>
                        <div @click="lookRow(form.start)" class="date">
                            {{form.start.update_time}}
                        </div>
                    </el-card>
                    <el-card v-else shadow="never" class="card_item">
                        <div class="add_box" @click="openDialog('start')">
                            <i class="el-icon-plus"></i>
                        </div>
                    </el-card>
                </el-form-item>
                <el-form-item v-if="middle" label="期中">
                    <el-card shadow="never"
                             v-if="form.middle"
                             class="card_item">
                        <div class="btn_box">
                            <div class="icon" @click="delRow('middle')">
                                <el-tooltip class="item"
                                            effect="dark"
                                            content="删除"
                                            placement="top">
                                    <i class="el-icon-delete"></i>
                                </el-tooltip>
                            </div>
                        </div>
                        <div class="img_box" @click="lookRow(form.middle)">
                            <img :src="showImgUrl(form.middle)">
                        </div>
                        <div @click="lookRow(form.middle)" class="title">
                            {{form.middle.title}}
                        </div>
                        <div @click="lookRow(form.middle)" class="text">
                            {{form.middle.brief}}
                        </div>
                        <div @click="lookRow(form.middle)" class="date">
                            {{form.middle.update_time}}
                        </div>
                    </el-card>
                    <el-card v-else shadow="never" class="card_item">
                        <div class="add_box" @click="openDialog('middle')">
                            <i class="el-icon-plus"></i>
                        </div>
                    </el-card>
                </el-form-item>
                <el-form-item v-if="end" label="期末">
                    <el-card shadow="never"
                             v-if="form.end"
                             class="card_item">
                        <div class="btn_box">
                            <div class="icon" @click="delRow('end')">
                                <el-tooltip class="item"
                                            effect="dark"
                                            content="删除"
                                            placement="top">
                                    <i class="el-icon-delete"></i>
                                </el-tooltip>
                            </div>
                        </div>
                        <div class="img_box" @click="lookRow(form.end)">
                            <img :src="showImgUrl(form.end)">
                        </div>
                        <div @click="lookRow(form.end)" class="title">
                            {{form.end.title}}
                        </div>
                        <div @click="lookRow(form.end)" class="text">
                            {{form.end.brief}}
                        </div>
                        <div @click="lookRow(form.end)" class="date">
                            {{form.end.update_time}}
                        </div>
                    </el-card>
                    <el-card v-else shadow="never" class="card_item">
                        <div class="add_box" @click="openDialog('end')">
                            <i class="el-icon-plus"></i>
                        </div>
                    </el-card>
                </el-form-item>
            </el-form>
            <div class="bottom_btn" v-if="start || middle || end">
                <el-button :disabled="submit_disable"
                           @click="submit_push"
                           type="primary">提交</el-button>
                <el-button @click="goBack">取消</el-button>
            </div>
        </div>

        <div class="html_box" v-if="showHtmlLook">
            <div class="btn_box">
                <div class="btn nomal_btn" @click="showHtmlLook = false">
                    <i class="el-icon-back"></i>
                    返回
                </div>
            </div>
            <div class="header">
                <div class="title">
                    {{look_row.title}}
                </div>
                <div class="author">
                    {{look_row.create_time}} {{look_row.create_user.name}}
                </div>
            </div>
            <div class="main" v-html="look_row.content"></div>
        </div>

        <div class="dialog_all" v-show="dialogSelectText">
            <div class="header">{{dialog_title}}</div>
            <div class="text_box">
                <div class="search_item">
                    <div class="title">标题：</div>
                    <div class="input_box">
                        <el-input v-model="search_name"
                                  @change="getTableData()"
                                  size="small"
                                  class="width_220">
                            <el-button slot="append"
                                       @click="getTableData()"
                                       icon="el-icon-search"></el-button>
                        </el-input>
                    </div>
                </div>
                <div class="card_table">
                    <el-card shadow="never"
                             v-for="(item, index) in tableData"
                             :key="index"
                             class="card_item">
                        <div class="btn_box">
                            <div class="icon"
                                 :class="select_text.paper_id == item.paper_id?'actived_icon':''"
                                 @click="selectRow(item)">
                                <el-tooltip class="item"
                                            effect="dark"
                                            content="选择"
                                            placement="top">
                                    <i class="el-icon-check"></i>
                                </el-tooltip>
                            </div>
                        </div>
                        <div class="img_box" @click="lookRow(item)">
                            <img :src="showImgUrl(item)" alt="">
                        </div>
                        <div @click="lookRow(item)" class="title">
                            {{item.title}}
                        </div>
                        <div @click="lookRow(item)" class="text">
                            {{item.brief}}
                        </div>
                        <div @click="lookRow(item)" class="date">
                            {{item.update_time}}
                        </div>
                    </el-card>
                </div>
            </div>
            <div class="bottom_btn">
                <el-button @click="closeDia()">取 消</el-button>
                <el-button type="primary"
                           :disabled="submit_disable_dia"
                           @click="submitSelect()">确 定</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import {clone} from "../../global/utils";
    import {mapState} from 'vuex'

    export default {
        name: "setTextPush",
        data() {
            return {
                viewTitle: '定点推送',
                dialog_title: '选择图文',
                start: false,
                middle: false,
                end: false,

                form: {
                    start: null,
                    middle: null,
                    end: null,
                },
                rules: {

                },

                showHtmlLook: false,
                look_row: {},

                base_select_table_data: [],
                dialogSelectText: false,
                open_select_type: '',
                search_name: '',
                tableData: [],
                select_text: {},
            }
        },
        computed: {
            ...mapState('learnData', {
                pushData: 'pushData',
                linePushData: 'linePushData',
            }),
            submit_disable_dia() {
                return JSON.stringify(this.select_text) === '{}'
            },
            submit_disable() {
                let a = this.form.start === null;
                let b = this.form.middle === null;
                let c = this.form.end === null;
                return a && b && c
            }
        },
        mounted() {
            this.base_select_table_data = this.pushData.cycle_items;
            if (this.linePushData) {
                this.viewTitle = this.linePushData.item_type + '定点推送';
                this.dialog_title = '选择' + this.linePushData.item_type;
                if (this.linePushData.cycle_start_item) {
                    this.form.start = clone(this.linePushData.cycle_start_item);
                    this.start = true;
                }
                if (this.linePushData.cycle_middle_item) {
                    this.form.middle = clone(this.linePushData.cycle_middle_item);
                    this.middle = true;
                }
                if (this.linePushData.cycle_end_item) {
                    this.form.end = clone(this.linePushData.cycle_end_item);
                    this.end = true;
                }
            }
        },
        methods: {
            goBack() {
                this.$emit('changeTopTab', 'tableView')
            },
            showImgUrl(item) {
                if (item.cover.indexOf('http') > -1) {
                    return item.cover
                }
                return item.pre_file + item.cover
            },

            changeHeaderType() {
                this.form.start = this.start ? this.form.start : null;
                this.form.middle = this.middle ? this.form.middle : null;
                this.form.end = this.end ? this.form.end : null;
            },
            delRow(val) {
                this.form[val] = null
            },
            lookRow(row) {
                this.look_row = row;
                this.showHtmlLook = true
            },

            openDialog(val) {
                this.dialogSelectText = true;
                this.open_select_type = val;
                this.select_text = [];
                this.search_name = '';
                this.getTableData()
            },
            getTableData() {
                this.select_text = {};
                if (!this.search_name) {
                    this.tableData = clone(this.base_select_table_data);
                    return
                }
                let result = this.base_select_table_data.filter(
                    v => v.title.indexOf(this.search_name) > -1
                );
                this.tableData = result
            },
            selectRow(row) {
                this.select_text = row;
            },
            closeDia() {
                this.dialogSelectText = false;
                this.open_select_type = '';
            },
            submitSelect() {
                this.form[this.open_select_type] = clone(this.select_text);
                this.dialogSelectText = false;
            },

            submit_push() {
                console.log(this.pushData, '326');
                let params = {
                    tumour_id: this.pushData.tumour_id,
                    tumour_cycle_id: this.pushData.tumour_cycle_id,
                    item_type: this.pushData.item_type,
                    cycle_start_item_id: this.form.start?this.form.start.paper_id:null,
                    cycle_middle_item_id: this.form.middle?this.form.middle.paper_id:null,
                    cycle_end_item_id: this.form.end?this.form.end.paper_id:null,
                };
                this.httpPost('/push_cycle_timing_config', params).then(res => {
                    this.$message.success('创建定点推送成功！');
                    this.goBack()
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    $view_background: rgb(246,247,248);
    $btn_border: rgb(246,247,248);
    .context {
        width: 100%;
        height: 100%;
        background: $view_background;
        position: relative;
        .header {
            width: 100%;
            line-height: 50px;
            padding: 0 15px;
            box-sizing: border-box;
            display: flex;
            border-bottom: 1px solid #ddd;
            z-index: 1;
            /*color: #8d8d8d;*/
            .title {

            }
            .btn_box {
                padding-right: 20px;
                .btn {
                    margin-top: 10px;
                    border: 1px solid $btn_border;
                }
            }
        }

        .form_box {
            z-index: 1;
            .header_box {
                line-height: 50px;
                padding-left: 30px;
            }
            .card_item {
                width: 300px;
                height: 300px;
                position: relative;
                z-index: 1;
                margin: 0 5px 5px 0;
                &:hover {
                    .btn_box {
                        display: flex;
                    }
                }
                .btn_box {
                    position: absolute;
                    top: 10px;
                    right: 10px;
                    z-index: 9;
                    cursor: pointer;
                    display: none;
                    .icon {
                        width: 35px;
                        height: 35px;
                        background: #fff;
                        border-radius: 50%;
                        line-height: 35px;
                        text-align: center;
                        margin-right: 5px;
                        i {
                            font-size: 1.123rem;
                        }
                    }
                }
                .img_box {
                    width: 300px;
                    height: 180px;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
                .title {
                    line-height: 30px;
                    padding: 0 10px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
                .text {
                    font-size: 0.875rem;
                    color: #8d8d8d;
                    padding: 0 10px;
                    line-height: 30px;
                    height: 60px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
                .date {
                    font-size: 0.875rem;
                    color: #8d8d8d;
                    padding: 0 10px;
                    line-height: 30px;
                }

                .add_box {
                    width: 300px;
                    height: 300px;
                    text-align: center;
                    line-height: 300px;
                    font-size: 6rem;
                    color: #8c939d;
                    cursor: pointer;
                    &:hover {
                        box-sizing: border-box;
                        border: 1px dashed #409eff;
                    }
                }
            }

            .bottom_btn {
                margin-left: 60px;
            }
        }

        .html_box {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: 99;
            background: $view_background;
            .btn_box {
                width: 110px;
                .btn {
                    margin-top: 10px;
                    border: 1px solid $btn_border;
                }
            }
            .header {
                font-size: 2rem;
                line-height: 50px;
                margin-bottom: 10px;
                .title {
                    font-size: 2rem;
                    line-height: 50px;
                }
                .author {
                    margin-left: 20px;
                    font-size: .75rem;
                    color: #9B9B9B;
                    line-height: 30px;
                    padding-top: 20px;
                }
            }
            .main {
                box-sizing: border-box;
            }
        }

        .dialog_all {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            display: flex;
            flex-flow: column;
            z-index: 3;
            background: #fff;
            .header {
                flex: 0 0 50px;
                width: 100%;
                box-sizing: border-box;
            }
            .bottom_btn {
                flex: 0 0 50px;
                line-height: 50px;
                text-align: right;
                padding-right: 50px;
                width: 100%;
                box-sizing: border-box;
                border-top: 1px solid #ddd;
            }
            .text_box {
                flex: 1;
                width: 100%;
                padding: 5px;
                box-sizing: border-box;
                height: calc(100% - 100px);
                .search_item {
                    line-height: 40px;
                    height: 40px;
                    display: flex;
                    padding-left: 10px;
                }
                .card_table {
                    height: calc(100% - 80px);
                    display: flex;
                    flex-wrap: wrap;
                    align-content: flex-start;
                    overflow: hidden;
                    overflow-y: auto;
                    box-sizing: border-box;
                    .card_item {
                        width: 300px;
                        height: 300px;
                        position: relative;
                        z-index: 1;
                        margin: 0 5px 5px 0;

                        .btn_box {
                            position: absolute;
                            top: 10px;
                            right: 10px;
                            z-index: 9;
                            cursor: pointer;
                            display: flex;
                            .icon {
                                width: 35px;
                                height: 35px;
                                background: #fff;
                                border-radius: 50%;
                                line-height: 35px;
                                text-align: center;
                                margin-right: 5px;
                                border: 1px solid #fff;
                                i {
                                    font-size: 1.123rem;
                                }
                            }
                            .actived_icon {
                                color: #fff;
                                background-color: #66b1ff;
                            }
                        }
                        .img_box {
                            width: 300px;
                            height: 180px;
                            img {
                                width: 100%;
                                height: 100%;
                            }
                        }
                        .title {
                            line-height: 30px;
                            padding: 0 10px;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                        }
                        .text {
                            font-size: 0.875rem;
                            color: #8d8d8d;
                            padding: 0 10px;
                            line-height: 30px;
                            height: 60px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                        }
                        .date {
                            font-size: 0.875rem;
                            color: #8d8d8d;
                            padding: 0 10px;
                            line-height: 30px;
                        }
                    }
                }
            }
        }
    }

</style>